import { Theme } from "@radix-ui/themes";
import Routes from "./routes/Routes";
import "@radix-ui/themes/styles.css";

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from './components/Toaster';
import RelayProvider from './relay/RelayProvider';


const queryClient = new QueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Theme>
        <RelayProvider>
          <Routes />
        </RelayProvider>
      </Theme>
      <Toaster />
    </QueryClientProvider>
  )
}
